import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaymentVerificationService } from '../../../../services/payment-verification.service';
import { PurchaseService } from '../../../../services/purchase.service';
import { PurchaseFormService } from '../../../../services/purchase-form.service';

@Component({
  selector: 'app-payment-cancel',
  templateUrl: './payment-cancel.component.html',
  styleUrls: ['./payment-cancel.component.css'],
  standalone: true,
  imports: [TranslateModule],
})
export class PaymentCancelComponent implements OnInit {
  specialTicketProductId: string | null = null;
  isReady = false;

  constructor(
    private verificationService: PaymentVerificationService,
    private purchaseService: PurchaseService,
    private formService: PurchaseFormService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const orderIdFromUrl = urlParams.get('orderId');
    if (orderIdFromUrl) {
      sessionStorage.setItem('pendingOrderId', orderIdFromUrl);
    }

    this.specialTicketProductId = sessionStorage.getItem('pendingSpecialTicketProductId');

    this.translateService.get('web.paymentCancelledHeading').subscribe(value => {
      if (value !== 'web.paymentCancelledHeading') {
        this.isReady = true;
      }
    });
  }

  async onTryAgain(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('id');

    if (!sessionId) {
      return;
    }

    await this.purchaseService.resubmitOrder(sessionId);
  }

  async onGoBack(): Promise<void> {
    this.formService.restoreFormState();
    await this.verificationService.cancelOrder();

    const specialTicketProductId = this.route.snapshot.paramMap.get('id');

    if (specialTicketProductId) {
      this.router.navigate(['/eventticket', specialTicketProductId]);
    } else {
      this.router.navigate(['/']);
    }
  }
}
